import React, { useState, useEffect, useRef } from "react";
import { Formik, Field, ErrorMessage } from "formik";
import {
  Button,
  Modal,
  ModalBody,
  ModalHeader,
  Form,
  FormGroup,
} from "reactstrap";
import { useSelector } from "react-redux";
import * as Yup from "yup";
import PinInput from "react-pin-input";
import SvgImage from "../../../Icons/Icons";
import { toast } from "react-toastify";
import { ToastContainer } from "react-toastify";
import "./index.css";

import { useDispatch } from "react-redux";
import {
  addMoney,
  cleanAdvanceDriverList,
  clearAllDrivers,
  clearAllDriversByVrn,
  expenseSumm,
  getAdvanceDriverList,
  getDriverList,
} from "../../../../services/Store/Actions/driverslistActions";
import moment from "moment";
// import { allCardsBalance } from "../../../services/Store/Actions/cardWalletAction";
import { getMasterWalletBalance } from "../../../../services/Store/Actions/masterWalletActions";
import { fetchBalance } from "../../../../services/Store/Actions/manageCardActions";
import { transferToCard } from "../../../../services/Store/Actions/manageCardActions";
import {
  clearLRList,
  collectPaymentfromBank,
  editLedgerExpense,
  getLRList,
  getTripsNew,
  viewBankStatement,
} from "../../../../services/Store/Actions/TripsAction";
import {
  sendAnalitics,
  storeMedia,
  toastStatus,
} from "../../../../services/Store/Actions/appActions";

import { ClipLoader } from "react-spinners";
import { Switch } from "@material-ui/core";
import ListModal from "../../../subComponents/ListModal";
import { advancedVehicleListAction } from "../../../../services/Store/Actions/fleetActions";
import {
  clearAllFleets,
  getVehicleListAction,
} from "../../../../services/Store/Actions/manageVehicleAction";
import {
  cleanInvoiceListSuccessAction,
  getAllCustomersAction,
  getInvoiceListAction,
} from "../../../../services/Store/Actions/customerAction";
import { DatePickerField } from "../../../core/inputs/input";
import ProgessLoader from "../../../core/ProgessBar";
const MapCustomerLedger = (props) => {
  const dispatch = useDispatch();
  const {
    open,
    toggleModal,
    handleClose,
    name,
    fleetId,
    vehRegNo,
    openChooseMethod,
    itemTemp,
    ledgerData,
  } = props;

  let { loader } = useSelector(
    (store) => store?.trip
  );

  const customerList = useSelector((state) => state?.customer?.customerList);
  const loader1 = useSelector((state) => state?.customer?.loader);

  const { freightListCount, freightList, fetchfreightList } = useSelector(
    (state) => state?.trip
  );

  const { customer, invoiceList, invoiceCount } = useSelector(
    (state) => state.customer
  );

  console.log("jijwijfijrwe", customerList, freightList.invoiceList);

  // useEffect(() => {}, [props]);
  console.log("xrt3rrrrexr", ledgerData, ledgerData?.Trip?.tripNo);
  const [customerId, setCustomerId] = useState("");
  const [displayDrivers, setDisplayDrivers] = useState(false);
  const [displayVehicles, setDisplayVehicles] = useState(false);
  const [displayTrip, setDisplayTrips] = useState(false);
  const [search1, setSearch1] = useState("");
  const [userId, setUserId] = useState("");
  const [search2, setSearch2] = useState("");
  const [search3, setSearch3] = useState("");

  const [driverColor, setDriverColor] = useState(-1);

  const [vehicleColor, setVehicleColor] = useState(-1);
  const [tripColor, setTripColor] = useState(-1);

  const expenseType = [
    { value: "Food" },
    { value: "Service" },
    { value: "Fuel" },
    { value: "Salary" },
    { value: "Fastag" },
    { value: "Others" },
  ];
  const transferType = [{ value: "credit" }, { value: "debit" }];
  const findSearch2 = (customerId) => {
    // dispatch(clearLRList());
    // dispatch(
    //   getLRList({
    //     customerId: customerId || "",
    //     lrNo: search2,
    //   })
    // );
  };

  useEffect(() => { 
    let timeout;
    if(displayVehicles && customerId){
      dispatch(clearLRList());
      if (search2 == "") {
        console.log("jijijr", search2);
        dispatch(
          getLRList({
            customerId: customerId || "",
            lrNo: search2,
          })
        );
      }
      else {
        timeout = setTimeout(() => {
          dispatch(
            getLRList({
              customerId: customerId || "",
              lrNo: search2,
            })
          );
        }, 250);
        return () => {
          clearTimeout(timeout);
        };  
      }
    }
  },[search2,displayVehicles])

  

  const findSearch1 = (customerId) => {
    // dispatch(cleanInvoiceListSuccessAction());
    // dispatch(
    //   getInvoiceListAction({
    //     customerId: customerId || "",
    //     search: search1,
    //     transferType: "unpaid",
    //   })
    // );
  };

  useEffect(() => { 
    let timeout;
    if(displayDrivers && customerId){
      dispatch(cleanInvoiceListSuccessAction());
      if (search1 == "") {
        console.log("jijijr", search1);
        dispatch(
          getInvoiceListAction({
            customerId: customerId || "",
            search: search1,
            transferType: "unpaid",
          })
        );
      }
      else {
        timeout = setTimeout(() => {
          dispatch(
            getInvoiceListAction({
              customerId: customerId || "",
              search: search1,
              transferType: "unpaid",
            })
          );
        }, 250);
        return () => {
          clearTimeout(timeout);
        };  
      }
    }
  },[search1,displayDrivers])

  const findSearch3 = () => {
    console.log("mkndkonfgkn", search3);
    // dispatch(
    //   getAllCustomersAction({
    //     offset: "",
    //     companyName: search3,
    //     minKyc: "",
    //     sortAs: "",
    //     sortBy: "",
    //     // limit: "12",
    //   })
    // );
  };

  useEffect(() => { 
    let timeout;
    if(displayTrip){
      if (search3 == "") {
        console.log("jijijr", search3);
        dispatch(
          getAllCustomersAction({
            offset: "",
            companyName: search3,
            minKyc: "",
            sortAs: "",
            sortBy: "",
            // limit: "12",
          })
        );
      }
      else {
        timeout = setTimeout(() => {
          dispatch(
            getAllCustomersAction({
              offset: "",
              companyName: search3,
              minKyc: "",
              sortAs: "",
              sortBy: "",
              // limit: "12",
            })
          );
        }, 250);
        return () => {
          clearTimeout(timeout);
        };  
      }
    }
  },[search3,displayTrip])



  useEffect(() => {
    setSearch1("");
    setSearch2("");
    setSearch3("");
    setDriverColor(-1);
    setDisplayDrivers(false);
    setDisplayVehicles(false);
    setDisplayTrips(false);
    setVehicleColor(-1);
    setTripColor(-1);

  }, []);

  const openBox1 = () => {
    // console.log("nananannana",displayDrivers)
    setDisplayDrivers(true);
  };
  const openBox2 = () => {
    // console.log("nananannana",displayDrivers)
    setDisplayVehicles(true);
  };

  const closeBox1 = () => {
    // console.log("nananannana",displayDrivers)
    setDisplayDrivers(false);
  };
  const closeBox2 = () => {
    // console.log("nananannana",displayDrivers)
    setDisplayVehicles(false);
  };

  const openBox3 = () => {
    // console.log("nananannana",displayDrivers)
    setDisplayTrips(true);
  };

  const closeBox3 = () => {
    // console.log("nananannana",displayDrivers)
    setDisplayTrips(false);
  };

  const datepickerRef = useRef();
  const handleClickDatepickerIcon = () => {
    const datepickerElement = datepickerRef.current;
    // console.log("datepickerElement = ", datepickerElement);
    datepickerElement.setOpen(!datepickerElement.open);
  };

  const handleKeyPress = (newSearchVal, divName) => {
    //alert("search again", newSearchVal,divName);
    console.log("search1", newSearchVal);
    console.log("search2", divName);
    // dispatch(
    //   getAdvanceDriverList({
    //     offset: 0,
    //     search: newSearchVal.trim(),
    //     minKyc: "",
    //     sortAs: "",
    //     sortBy: "",
    //     activeStatus: "",
    //     assignedStatus: "",
    //   })
    // );
  };
  // useEffect(() => {}, [fleetId]);
  return (
    <div>
      <Modal
        isOpen={open}
        onHide={handleClose}
        className="positons settingModalMargin"
        toggle={toggleModal}
        aria-labelledby="myModalLabel2"
      >
        <div
          className="modal-content"
          style={{ width: "530px", overflowY: "scroll", overflowX: "hidden" }}
        >
          <div className="modal-head-part">
            <p className="Add-balance-title">{name}</p>
            <Button
              type="button"
              className="close-btn"
              onClick={() => {
                if (!loader) {
                  toggleModal();
                }
              }}
              aria-label="Close"
            >
              <SvgImage name="CloseButtonLogo" />
            </Button>
          </div>
          <ModalBody>
            {/* <div className="card-wallet-icon-body2">
              <SvgImage
                name="cardWalletLogo"
                height="43.81"
                width="43.81"
                classname="card-wallet-logo-BankLogo"
              />
              <div>
                <p className="body-sub-part1-ab">Master Account Balance</p>
                <p className="body-sub-part2-ab">₹{LogipeAccounBal}</p>
              </div>
            </div> */}
            {/* <div
              className="flexStyling sub-head-3"
              style={{ justifyContent: "center", marginTop: "20px" }}
            >
              <div> Cash</div>
              <div style={{ marginTop: "-7px" }}>
                <Switch
                  checked={card}
                  onChange={(e) => {
                    setCard(!card);
                  }}
                  handleDiameter={20}
                  height={15}
                  width={40}
                  id="material-switch"
                />
              </div>
              <div>Card</div>
            </div> */}
            <Formik
              enableReinitialize
              initialValues={{
                amount: ledgerData?.amount || "",
                remark: "",
                // type: ledgerData?.expanseTag || "",
                expDate: ledgerData?.expDate,
                customerId: "",
                invoiceId: "",
                freightId: "",
                invoice: "",
                freight: "",
                customer: "",
                lrData : "",
                description: ledgerData?.description || "",
              }}
              //validationSchema={validationSchema}
              onSubmit={(values, actions) => {
                // values.bookingDate = moment(values.bookingDate).format(
                //   "DD-MM-YYYY"
                // );
                //console.log("date",moment(values.bookingDate).format('DD-MM-YYYY'))
                let toggleModalToast=() => {
                  dispatch(
                    toastStatus({
                      toastStatus: false,
                    })
                  );
                }
                let handleCloseToast=() => {
                  dispatch(
                    toastStatus({
                      toastStatus: false,
                    })
                  );
                }
                if (values?.customerId) {
                  console.log("kkkkknnannaann", values);
                  let finalData = {
                    customerId: values?.customerId,
                    amount: values?.amount ? values?.amount : "",
                    paymentDate:values?.expDate
                    ? moment(values?.expDate).format("YYYY-MM-DD")
                    : "",
                    txnNumber : ledgerData["referenceNumber"],
                    freightId: values?.freightId || "",
                    invoiceId: values?.invoiceId || "",
                    remark : values?.remark || "",
                    description : values?.description || "",
                    bankLedgerId : ledgerData?.bankLedgerId,
                    refData : {
                      customer : values?.customer || "",
                      customerId: values?.customerId || "",
                      lrData : values?.lrData || "",
                    }
                  };
                  // if (values?.tripId) {
                  //   finalData["tripId"] = values?.tripId;
                  // }

                  // if (values?.otherRemarks) {
                  //   finalData["otherRemarks"] = values?.otherRemarks;
                  // }
                  
                  dispatch(
                    collectPaymentfromBank(finalData, (res) => {
                      actions.setSubmitting(false);
                      // dispatch(
                      //   sendAnalitics("Success_Add_Bal_DriverCard_Web", {
                      //     amt: values.amount,
                      //     pin: values.pin,
                      //     remark: values.remark,
                      //     fleetId: fleetId,
                      //   })
                      // );
                      if (res?.status == 200) {
                        console.log("successful");
                        //navigate("/Customers")
                        dispatch(
                          viewBankStatement({
                            offset: 0,
                            limit: 10,
                            bankId: props.bankId || null,
                            sortBy : "expDate",
                            sortAs : (props?.sortDirection) == "asc" ? "ASC" : "", 
                            from : props?.from,
                            to : props?.to,
                            transferType : props?.transferType,
                            mode : props?.mode,
                            offset : props?.offset,
                          })
                        );
                        // dispatch(expenseSumm(fleetId));
                        // window.location.reload();
                        toggleModal();
                      }
                    }),    toggleModalToast,
                    handleCloseToast
                  );
                }  else {
                  toast.error("please select user again.");
                }

                //   // addMoney(values, fleetId, (res) => {
                //   //   actions.setSubmitting(false);
                //   //   if (res?.data?.type === "success") {
                //   //     console.log("successful");
                //   //     //navigate("/Customers")
                //   //     dispatch(expenseSumm(fleetId));
                //   //     toggleModal();
                //   //   }
                //   // })
                // );
              }}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                setFieldValue,
                isSubmitting,
                /* and other goodies */
              }) => (
                <Form onSubmit={handleSubmit}>
                  <div>
                    <div className="sub-title-1">
                      <span class="circle-logo">1</span>
                      <p className="sub-head-3">Enter amount</p>
                    </div>
                    <p className="sub-head-body">
                      Amount will be deducted from owner’s LogiPe account
                    </p>

                    <input
                      type="text"
                      id="html"
                      className={
                        "input-body-1 form-control" +
                        (errors.amount && touched.amount ? " is-invalid" : "")
                      }
                      name="amount"
                      value={values.amount}
                      touched={touched.amount}
                      errors={errors.amount}
                      onBlur={handleBlur("amount")}
                      onChange={handleChange("amount")}
                    ></input>
                    <div className="input-amount"></div>
                    <ErrorMessage
                      name="amount"
                      component="div"
                      className="invalid-feedback"
                    />
                  </div>

                  <div>
                    <div className="sub-title-1">
                      <span class="circle-logo">2</span>
                      <p className="sub-head-3">Description</p>
                    </div>
                    <p className="sub-head-body">
                      Enter Description Number to Add This Expense
                    </p>

                    <input
                      type="text"
                      id="description"
                      // readonly="readonly"
                      className={
                        "input-body-1 form-control" +
                        (errors.description && touched.description
                          ? " is-invalid"
                          : "")
                      }
                      name="description"
                      value={values.description}
                      // touched={touched.vehRegNo}
                      // errors={errors.vehRegNo}
                      // onBlur={handleBlur("vehRegNo")}
                      onChange={handleChange("description")}
                    />
                    <div className="input-amount"></div>
                    {/* <ErrorMessage
                      name="vehRegNo"
                      component="div"
                      className="invalid-feedback"
                    /> */}
                  </div>

                  <FormGroup>
                    <div className="sub-title-1">
                      <span class="circle-logo">3</span>
                      <p className="sub-head-3">Search Customer</p>
                    </div>
                    <label for="html" className="label-body"></label>
                    <input
                      type="text"
                      id="customer"
                      className="input-body-3"
                      name="customer"
                      onFocus={() => {
                        findSearch3();
                        openBox3();
                      }}
                      style={{ marginLeft: "0" }}
                      onChange={(event) => {
                        findSearch3();
                        setDisplayTrips(true);
                        // dispatch(clearAllDrivers());
                        dispatch(
                          sendAnalitics("Search_DC_MA_Web", {
                            searchDriverName: event.target.value,
                          })
                        );
                        console.log("eeeeeeeeeeeeeeeee", event.target.value);
                        // setDisplay(true);
                        setSearch3(event.target.value);
                        // setLoading(true);
                        setFieldValue("customer", event.target.value, true);
                        if (event.target.value == "") {
                          setCustomerId("");
                          setFieldValue("customerId", "", true);
                          setFieldValue("ledgerId", "", true);
                          setFieldValue("freightId", "", true);
                          setFieldValue("customer", "", true);
                          setFieldValue("ledger", "", true);
                          setFieldValue("freight", "", true);
                        }
                      }}
                      value={values.customer}
                      onBlur={() => {
                        console.log("===>>>>>kkkkk");
                        handleBlur("customer");
                        closeBox3();
                      }}
                      touched={touched.customer}
                      errors={errors.customer}
                      onKeyUp={(e) => {
                        if (e.key === "Backspace") {
                          findSearch3();
                        }
                      }}
                      autocomplete="off"
                      placeholder="Search customer's name"
                    />
                    <div className="input-amount">
                      {displayTrip ? (
                        <ListModal
                          placeholder="Search"
                          handleKeyPress={handleKeyPress}
                          divName="customerList"
                          // text="Select by driver name"
                          listing={customerList}
                          // handlingDivSelect={handlingDivSelect}
                          displayDrivers={displayTrip}
                          setDisplayDrivers={setDisplayTrips}
                          // displayVehicles={displayVehicles}
                          // setDisplayVehicles={setDisplayVehicles}
                          color={tripColor}
                          setColor={setTripColor}
                          loading={loader1}
                          setFieldValue={setFieldValue}
                          userId={userId}
                          setUserId={setUserId}
                          setCustomerId={setCustomerId}
                        />
                      ) : (
                        <></>
                      )}
                    </div>
                  </FormGroup>

                  <FormGroup>
                    <div className="sub-title-1">
                      <span class="circle-logo">4</span>
                      <p className="sub-head-3">Search Invoices</p>
                    </div>
                    <label for="html" className="label-body"></label>
                    <input
                      type="text"
                      disabled={values?.customerId && !values?.freight ? false : true}
                      id="invoice"
                      className="input-body-3"
                      name="invoice"
                      onFocus={() => {
                        findSearch1(values?.customerId);
                        openBox1();
                      }}
                      style={{ marginLeft: "0" }}
                      onChange={(event) => {
                        findSearch1(values?.customerId);
                        setDisplayDrivers(true);
                        // dispatch(clearAllDrivers());
                        dispatch(
                          sendAnalitics("Search_DC_MA_Web", {
                            searchinvoice: event.target.value,
                          })
                        );
                        console.log("eeeeeeeeeeeeeeeee", event.target.value);
                        // setDisplay(true);
                        setSearch1(event.target.value);
                        // setLoading(true);
                        setFieldValue("invoice", event.target.value, true);
                        if (event.target.value == "") {
                          setFieldValue("invoiceId", "", true);
                        }
                      }}
                      value={values.invoice}
                      onBlur={() => {
                        console.log("===>>>>>kkkkk");
                        handleBlur("invoice");
                        closeBox1();
                      }}
                      touched={touched.invoice}
                      errors={errors.invoice}
                      onKeyUp={(e) => {
                        if (e.key === "Backspace") {
                          findSearch1(values?.customerId);
                        }
                      }}
                      autocomplete="off"
                      placeholder="Search invoices's name"
                    />
                    <div className="input-amount">
                      {displayDrivers ? (
                        <ListModal
                          placeholder="Search"
                          handleKeyPress={handleKeyPress}
                          divName="invoiceList"
                          // text="Select by driver name"
                          listing={invoiceList}
                          // handlingDivSelect={handlingDivSelect}
                          displayDrivers={displayDrivers}
                          setDisplayDrivers={setDisplayDrivers}
                          // displayVehicles={displayVehicles}
                          // setDisplayVehicles={setDisplayVehicles}
                          color={driverColor}
                          setColor={setDriverColor}
                          loading={loader1}
                          setFieldValue={setFieldValue}
                          userId={userId}
                          setUserId={setUserId}
                        />
                      ) : (
                        <></>
                      )}
                    </div>
                  </FormGroup>
                  <FormGroup>
                    <div className="sub-title-1">
                      <span class="circle-logo">5</span>
                      <p className="sub-head-3">Search LR Number</p>
                    </div>
                    <label for="html" className="label-body"></label>
                    <input
                      type="text"
                      disabled={values?.customerId && !values?.invoice ? false : true}
                      id="freight"
                      className="input-body-3"
                      name="freight"
                      style={{ marginLeft: "0" }}
                      autocomplete="off"
                      onFocus={() => {
                        findSearch2(values?.customerId);
                        openBox2();
                      }}
                      onBlur={closeBox2}
                      onChange={(event) => {
                        findSearch2(values?.customerId);
                        // setDisplay2(true);
                        // dispatch(clearAllDrivers());
                        dispatch(
                          sendAnalitics("Search_DC_MA_Web", {
                            searchDriverName: event.target.value,
                          })
                        );
                        console.log("eeeeeeeeeeeeeeeee", event.target.value);
                        // setDisplay(true);
                        setSearch2(event.target.value);
                        setFieldValue("freight", event.target.value, true);
                        if (event.target.value == "") {
                          setFieldValue("freightId", "", true);
                          setFieldValue("lrData", "", true);
                        }
                      }}
                      value={values.freight}
                      // onBlur={handleBlur("freight")}
                      touched={touched.freight}
                      errors={errors.freight}
                      onKeyUp={(e) => {
                        if (e.key === "Backspace") {
                          findSearch2(values?.customerId);
                        }
                      }}
                      placeholder="Search LR's Number"
                    />
                    <div className="input-amount">
                      {displayVehicles ? (
                        <ListModal
                          placeholder="Search"
                          handleKeyPress={handleKeyPress}
                          divName="freightList"
                          // text="Select by driver name"
                          listing={freightList}
                          // handlingDivSelect={handlingDivSelect}
                          displayDrivers={displayVehicles}
                          setDisplayDrivers={setDisplayVehicles}
                          // displayVehicles={displayVehicles}
                          // setDisplayVehicles={setDisplayVehicles}
                          color={vehicleColor}
                          setColor={setVehicleColor}
                          loading={fetchfreightList}
                          setFieldValue={setFieldValue}
                          userId={userId}
                          setUserId={setUserId}
                        />
                      ) : (
                        <></>
                      )}
                    </div>

                    {/* <div style={{ margin: "7px 0 0px 96px", color: "red" }}>
                      {errors.vrn && touched.vrn ? (
                        <div>*{errors.vrn}</div>
                      ) : null}
                    </div> */}
                  </FormGroup>

                  <div>
                    <div className="sub-title-1">
                      <span class="circle-logo">6</span>
                      <p className="sub-head-3">Enter remarks</p>
                    </div>
                    <p className="sub-head-body">
                      Enter the the remarks/comments
                    </p>

                    <input
                      type="text"
                      id="html"
                      className={
                        "input-body-1 form-control" +
                        (errors.remark && touched.remark ? " is-invalid" : "")
                      }
                      name="remark"
                      value={values.remark}
                      touched={touched.remark}
                      errors={errors.remark}
                      onBlur={handleBlur("remark")}
                      onChange={handleChange("remark")}
                    ></input>
                    <div className="input-amount"></div>
                    <ErrorMessage
                      name="remark"
                      component="div"
                      className="invalid-feedback"
                    />
                  </div>

                  <FormGroup>
                    <div className="sub-title-1">
                      <span class="circle-logo">7 </span>
                      <label className="sub-head-3 ">Transaction Date</label>
                    </div>
                    <DatePickerField
                      name="expDate"
                      className={
                        "input-body-3 form-control" +
                        (errors.expDate && touched.expDate ? " is-invalid" : "")
                      }
                      value={values.expDate}
                      header="Select booking date"
                      onChange={(v) => setFieldValue("expDate", v, true)}
                      maxDate={new Date()}
                      ref1={datepickerRef}
                    />
                    <label
                      className="date-input"
                      style={{
                        color: "black",
                        position: "relative",
                        top: "-2rem",
                        left: "-1.4rem",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        handleClickDatepickerIcon();
                      }}
                    >
                      <SvgImage
                        style={{ marginRight: "1rem" }}
                        name="CalenderLogo"
                        width="32"
                        height="32"
                        classname="date-logo"
                      />
                    </label>

                    <div className="input-amount-for-link"></div>
                    <div style={{ margin: "7px 0 0px 96px", color: "red" }}>
                      {errors.expDate && touched.expDate ? (
                        <div>*{errors.expDate}</div>
                      ) : null}
                    </div>
                    {/* <ErrorMessage
                      name="dob"
                      component="div"
                      className="invalid-feedback"
                    /> */}
                                        <Button
                      type="submit"
                      className="butt4"
                      disabled={loader ? true : false}
                      onClick={() => {
                        dispatch(
                          sendAnalitics("Add_Bal_DriverCard_fromMA_Web", {
                            amt: values.amount,
                            pin: values.pin,
                            remark: values.remark,
                            fleetId: fleetId,
                          })
                        );
                      }}
                    >
                                            {loader ?                      <>
                              <ProgessLoader
                              />
                            </> : "Map"}
                    </Button>
                  </FormGroup>
                </Form>
              )}
            </Formik>
          </ModalBody>
        </div>
        <ToastContainer
          theme="light"
          position="top-right"
          closeOnClick
          pauseOnHover
          autoClose={4000}
        />
      </Modal>
    </div>
  );
};
export default MapCustomerLedger;
